export function smoothAnchorScroll() {
$(document).on('click', 'a[href*="#"]', function (e) {
    var el = this;

    // Тільки внутрішні якорі на поточній сторінці
    if (location.pathname.replace(/^\//, '') !== el.pathname.replace(/^\//, '') ||
        location.hostname !== el.hostname) {
      return; // дозволяємо перехід на інші сторінки
    }

    // Отримуємо hash (наприклад "#section")
    var hash = el.hash;
    if (!hash || hash === '#' || hash === '#!') return; // пропускаємо пусті/псевдо-якорі

    var $target = $(hash);
    if (!$target.length) {
      // fallback: пошук по name="" (старі форми)
      $target = $('[name="' + hash.slice(1) + '"]');
    }

    if ($target.length) {
      e.preventDefault();

      // Відступ для прикинутого стікін-хедера (налаштуй селектор під свій header)
      var headerHeight = $('.header:visible').outerHeight() || 0;

      // Розрахунок позиції скролу
      var destination = Math.max(0, $target.offset().top - headerHeight);

      // Зупиняємо попередні анімації і анімимо
      $('html, body').stop(true).animate({
        scrollTop: destination
      }, 600);

      // Якщо треба закривати моб меню — можна тут:
      // $('#mobile-menu-wrapper').removeClass('active');

      return false;
    }
  });
}